<template>
<div class="row">
  <pos-format-close-box
      :data="data"
      ref="posFormatCloseBoxComponent"
    ></pos-format-close-box>

  <div class="col-md-12">
    <div class="card vx-card">
      <div class="card-body" v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
            <el-date-picker
                @change="changeRangeDates"
                v-model="rangeDates"
                type="daterange"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                range-separator="|"
                start-placeholder="Fecha inicial"
                end-placeholder="Fecha final"
              >
              </el-date-picker>
            <search-filter @executeSearch="search" :options="[]"></search-filter>
          </div>
          <div>
            <vs-button type="gradient" @click="newCloseBox()">
              <i class="fa fa-plus"></i>
              Generar Cierre
            </vs-button>
          </div>
        </div>

        <div id="data-list-list-view" class="data-list-container mt-5" v-if="items.length">
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Fecha de cierre</vs-th>
                <vs-th>Acciones</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td>
                      {{ item.created_at | moment("DD/MM/YYYY") }}
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <el-dropdown @command="itemAction">
                        <i class="fa fa-cogs text-primary"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="{ action: 'report', id: item.id }" class="text-success">
                            <i class="fa fa-print"></i>
                            Generar reporte
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ action: 'delete', payload: { id: item.id } }" class="text-danger">
                            <i class="fa fa-times"></i>
                            Eliminar
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>

          <div class="col-md-12 text-center" v-if="!loading && items.length == 0">
            <p>No hay cierres de caja.</p>
          </div>
      </div>
    </div>
  </div>

  
  </div>
</template>

<script>
import closeBoxesService from "@/services/close-boxes.service";
import SearchFilter from '@/components/SearchFilter.vue';
import RegistersPerPage from '@/components/RegistersPerPage';
import utilitiesService from "@/services/utilities.service";
import helpers from "@/helpers/helpers";
import moment from "moment";
import { Printd } from "printd";
import PosFormatCloseBox from '@/components/PosFormatCloseBox.vue';

export default {
  name: 'items',
  data() {
    return {
      items: [],
      loading: true,
      loadingSearch: false,
      pageCount : 1,
      perPage: 10,
      page: 1,
      searchData: {},
      item: {
        created_at: ""
      },
      brands: [],
      blobPdf: null,
      rangeDates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      ],
      data: {
        company: "",
        currency: "",
        documents: "",
        openBox: "",
        cashInvoices: "",
        cardInvoices: "",
        checkInvoices: "",
        depositInvoices: "",
        thirdInvoices: "",
        otherInvoices: "",
        cash: "",
        card: "",
        check: "",
        deposit: "",
        third: "",
        other: "",
        credit: "",
        total: "",
      },
      company: "",
      openBox: "",
      cashInvoices: [],
      total: "",
      show: false,
    }
  },
  methods: {
    printPos(id) {
      this.$refs.posFormatCloseBoxComponent.getCloseBox(id);
      // this.$refs.posFormatCloseBoxComponent.printPos();
    },
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num
      this.searchData = searchData
      this.getCloseBoxes(1, this.searchData)
    },
    search(search) {
      this.searchData = search;
      this.searchData.rangeDates = this.rangeDates.join(",");
      this.getCloseBoxes(1, this.searchData)
    },
    changeRangeDates() {
      this.searchData.rangeDates = this.rangeDates.join(",");
      this.getCloseBoxes(1, this.searchData, this.rangeDates);
    },
    getCloseBoxes(page = 1, search = {}) {
      this.searchData = search;
      this.searchData.rangeDates = this.rangeDates.join(",");
      closeBoxesService.getCloseBoxes(page, search).then(res => {
        this.items = res.data.data;
        // if (this.items.length > 0){
        //   this.getCloseBox(this.items[0].id);
        // }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        if(error.response.status == 401) {
          // localStorage.clear();
          // this.$router.push('login');
        }
      })
    },
    itemAction(command) {
      if(command.action == 'report') {
        //this.$router.push({name: 'edit-item', params: {id: command.id} });
        this.getCloseBox(command.id);
        // this.printPos(command.id);
      } else if(command.action == 'delete') {
         this.$confirm('¿ Deseas eliminar el cierre de caja ?', 'Eliminar Cierre de Caja', {
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            center: true
          }).then(() => {
            this.loading = true;
            let index = this.items.findIndex(i => i.id === command.payload.id);
            closeBoxesService.deleteCloseBox(command.payload.id)
            .then(() => {
              this.loading = false;
              this.items.splice(index, 1);
              this.$message({
                type: 'success',
                message: 'Cierre de Caja eliminada'
              });
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: 'Ocurrio un problema'
              });
            });
          }).catch(() => {
            this.loading = false;
            this.$message({
              type: 'info',
              message: 'Acción cancelada'
            });
          });
      }
    },
    getCloseBox(id) {
      closeBoxesService.getCloseBox(id)
      .then((res) => {
        this.data = res.data.data;
        // if (this.data.company != ""){
        //   console.log(this.data);
          this.printPos(id);
        // }
        // if (this.show){
        //   this.printPos();
        // }
        // else{
        //   this.show = true;
        // }
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      });
    },
    newCloseBox() {
      this.loading = true
      this.searchData.rangeDates = this.rangeDates.join(",");
      closeBoxesService.getInvoicesAmount(1, this.searchData)
        .then(res => {
          this.loading = false
          if (!res.data.success){
            console.log(res.data)
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error'
            });
          }
          else{
            // this.company = res.data.data.company;
            console.log(res.data.data)
            // this.data = res.data.data;
            // this.printPos(res.data.id);
            this.getCloseBox(res.data.id);
            this.getCloseBoxes();
          }
          
        })
        .catch((error) => {
          console.log(error)
          this.loading = false;
          this.blobPdf = null
          this.$message({
            showClose: true,
            message: "Ocurrio un error al cargar el reporte.",
            type: 'error'
          });
        })
        .finally(() => {
            this.loading = false;
            delete this.searchData.export;
          });
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    goPage(numPage) {
      this.getCloseBoxes(numPage, this.searchData);
    },
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getCloseBoxes();
  },
  components: {
    SearchFilter,
    RegistersPerPage,
    PosFormatCloseBox,
  }
};
</script>

<style scope>

.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
